import API from '../lib/API';
import { ListInvoices } from './contracts/CobreFacil.contract';

export const listInvoices = (customer_id: string | null): Promise<ListInvoices.Response> => {
    return API.get(`/cobre-facil/invoices/${customer_id}`);
};